import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//配件交易频次接口服务
class partDealService {
    /*****************************************************************************/

    //分页查询销售单信息
    static async findPage(data) {
        const apiUrl = "/statistics/salesByCustomer";
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/statistics/salesByCustomer/export`;
        return await download(apiUrl, {type: "POST", data});
    }


    /*****************************************************************************/
}

export default partDealService;
